import {
  temperatureWidgetData,
  windWidgetData,
} from '../globalWidgetsData';
import { ChartWidgetData, WidgetData } from '../types';

const humidityVCWidgetData: WidgetData = [
  {
    meteoCode: 'RH_PROC=AVE_T=10M_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

const visibilityVCWidgetData: WidgetData = [{
  meteoCode: 'V_PROC=-_T=10M_TYPE=0_Z=2M',
  sourceType: 'DATASOURCE',
  stationEntityId: -1,
  place: '',
  point: -1,
  time: null,
  measures: [
    {
      interval: 10,
      timeShift: 0,
      mandatory: true,
    },
  ],
}];

const atmospherePressureVCWidgetData: WidgetData = [{
  meteoCode: 'AP_PROC=AVE_T=10M_Z=STN',
  sourceType: 'DATASOURCE',
  stationEntityId: -1,
  place: '',
  point: -1,
  time: null,
  measures: [
    {
      interval: 10,
      timeShift: 0,
      mandatory: true,
    },
  ],
}];

const windDirectionMeteocodeId = 'WD_PROC=AVE_T=10M_TYPE=0_Z=10M';
const windRoseArrowVCWidgetData: WidgetData = [
  {
    meteoCode: windDirectionMeteocodeId,
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    place: '',
    point: -1,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];
const windRoseChartVSWidgetData: ChartWidgetData['dataInfo'][] = [
  {
    meteoCode: windDirectionMeteocodeId,
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    place: '',
    point: -1,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

const complexVCChart1: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'TA_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'RH_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'TD_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(69, 224, 76, 0.5)',
      backgroundColor: 'rgba(45, 158, 50, 0.5)',
      fill: false,
    },
  },
];
const complexVCChart2: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'AP_PROC=AVE_T=10M_Z=STN',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
];
const complexVCChart3: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'TA_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'P_PROC=SUM_T=24H_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 60 * 24, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(69, 224, 76, 0.5)',
      backgroundColor: 'rgba(45, 158, 50, 0.5)',
      fill: false,
    },
  },
];

export {
  temperatureWidgetData,
  windWidgetData,
  humidityVCWidgetData,
  visibilityVCWidgetData,
  atmospherePressureVCWidgetData,
  windRoseArrowVCWidgetData,
  windRoseChartVSWidgetData,
  complexVCChart1,
  complexVCChart2,
  complexVCChart3,
};
